import React from 'react';
import styled from 'styled-components';
import { object, string } from 'prop-types';

import Typography from 'ravenjs/lib/Typography';

import { DEFAULT_COLORS } from 'constants/colors';

const StyledTopography = styled(Typography)`
    border-radius: 20px;
    padding: 3px 16px 1px;
    margin-right: 16px;
`;

const CaseLabel = ({ title, color, fontSize, fontColor, style }) => (
    <StyledTopography
        type="span"
        backgroundColor={color}
        fontSize={fontSize}
        color={fontColor}
        style={style}
    >
        {title}
    </StyledTopography>
);

CaseLabel.propTypes = {
    title: string.isRequired,
    color: string.isRequired,
    fontSize: string,
    fontColor: string,
    style: object,
};

CaseLabel.defaultProps = {
    fontSize: '1rem',
    fontColor: DEFAULT_COLORS.BLACK,
    style: {},
};

export default CaseLabel;
